import React from "react";
import style from "../../styles/addtocart.module.scss";
import { useCart } from "react-use-cart";
import { toast } from "react-toastify";
import { trackAddToCart } from "../../utils/tracking";
import { IoCartOutline } from "react-icons/io5";

const AddToCart = ({ product, quantity }) => {
  const { addItem } = useCart();

  return (
    <button
      className={style.button}
      onClick={() => {
        addItem(product, quantity);
        toast.success("Produkti u shtua në shportë");
        trackAddToCart(product, quantity);
      }}
    >
      <IoCartOutline size={30} />
      Shto në shportë
    </button>
  );
};

export default AddToCart;
